import script from "./DriverViolationDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DriverViolationDetails.vue?vue&type=script&setup=true&lang=js"

import "./DriverViolationDetails.vue?vue&type=style&index=0&id=fa692344&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa692344"]])

export default __exports__